<template>
  <div id="app" :class="[theme]">
    <promo-section
      v-if="!$route.path.includes('/headphones/quiet-comfort-earbud')"
    />
    <main-navigation
      :class="{
        'products-page-nav': $route.path.includes(
          '/headphones/quiet-comfort-earbud'
        ),
      }"
    ></main-navigation>
    <product-nav v-if="$route.path.includes('/products/headphones/')" />
    <router-view />
    <mainFooter></mainFooter>
  </div>
</template>

<script>
import MainNavigation from "@/components/main-navigation";
import mainFooter from "@/components/main-footer";
import PromoSection from "@/components/promo-section";
import ProductNav from "@/components/product-nav";
export default {
  components: { PromoSection, mainFooter, MainNavigation, ProductNav },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },
};
</script>

<style lang="scss">
#app {
  color: #2c3e50;
  &.theme-dark {
    background: #000000;
  }

  &.theme-light {
    background: #ffffff;
  }
}
</style>
